export const UM_RES_NAME = 'team_management';
